import styled from 'styled-components'
import { calculateResponsiveSize } from 'helpers/calculateResponsiveSize'
import { mediaMax } from 'helpers/mediaQueries'
import ScrollDownSvg from 'icons/scroll-arrow.svg'

export const ScrollArrow = styled.div`
  position: absolute;
  z-index: 11;
  bottom: ${calculateResponsiveSize(20)};
  left: 50%;
  width: ${calculateResponsiveSize(92)};
  height: ${calculateResponsiveSize(46)};
  background: url(${ScrollDownSvg}) no-repeat;
  background-size: contain;
  animation: scrollDown 4s ease-in-out infinite;
  cursor: pointer;
  &.mobile {
    display: none;
  }
  @keyframes scrollDown {
    0% {
      transform: translate(-50%, -10px);
    }
    50% {
      transform: translate(-50%, 10px);
    }
    100% {
      transform: translate(-50%, -10px);
    }
  }
  ${mediaMax('tabletLandscape')} {
    width: 41px;
    height: 14px;
    bottom: 20px;
    &.desktop {
      display: none;
    }
    &.mobile {
      display: block;
    }
  }
`
